export const AboutUs = () => {
  return (
    <>
      <section className="pb-0" id="about">
        <div className="container">
          <div className="row">
            <div className="col-12 py-3">
              <div
                className="bg-holder bg-size"
                style={{
                  backgroundImage: "url(assets/img/gallery/about-us.png)",
                  backgroundPosition: "top center",
                  backgroundSize: "contain",
                }}
              ></div>
              <h1 className="text-center">ABOUT US</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div
          className="bg-holder bg-size"
          style={{
            backgroundImage: "url(assets/img/gallery/about-bg.png)",
            backgroundPosition: "top center",
            backgroundSize: "contain",
          }}
        ></div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-5 mb-lg-0">
              <img
                className="fit-cover rounded-circle w-100"
                src="assets/img/gallery/dr_richa.png"
                alt="..."
              />
            </div>
            <div className="col-md-6 text-center text-md-end">
              <h2 className="fw-bold mb-4">
                Meet Your Smile Specialist
                <br className="d-none d-sm-block" />
              </h2>
              <p>
                <strong>Dr. Richa Aggarwal,</strong> one of the <strong>best dentists in Amritsar</strong>,
                <br className="d-none d-sm-block" />
                {" "}received her Bachelor’s and Master’s degree in Dental
                <br className="d-none d-sm-block" />
                {" "}Surgery from Government Dental College, Amritsar. She
                <br className="d-none d-sm-block" />
                {" "} has completed her Master's in Orthodontics and Dentofacial 
                <br className="d-none d-sm-block" />
                {" "}orthopaedics {'('}braces specialist{')'} and has more than 10 years 
                <br className="d-none d-sm-block" />
                {" "}of clinical experience in diagnosis and treatment planning,
                <br className="d-none d-sm-block" />
                {" "} preventative care and prosthodontic dentistry.
                <br className="d-none d-sm-block" />
                {" "}At <strong>Aggarwal Dental Care, one of the best clinics in Amritsar</strong>,
                <br className="d-none d-sm-block" />
                {" "}Dr. Aggarwal believes that it is the dentist's responsibility  
                <br className="d-none d-sm-block" />
                {" "}to educate and guide patients so they can make informed 
                <br className="d-none d-sm-block" />
                {" "}decisions about their oral health with confidence.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
